/**
 * Strip markdown syntax from text to get plain text
 * Used for previews where we want clean text without formatting marks
 */
export const stripMarkdown = (text) => {
  if (!text) return '';
  return text
    // Remove code blocks first (before inline code)
    .replace(/```[\s\S]*?```/g, '')
    // Remove inline code
    .replace(/`([^`]+)`/g, '$1')
    // Remove bold **text** or __text__
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/__(.+?)__/g, '$1')
    // Remove italic *text* or _text_
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/_(.+?)_/g, '$1')
    // Remove strikethrough ~~text~~
    .replace(/~~(.+?)~~/g, '$1')
    // Remove images ![alt](url) — must come before links to avoid leaving "!"
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
    // Remove links [text](url)
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    // Remove headers # ## ### etc
    .replace(/^#{1,6}\s*/gm, '')
    // Remove unordered list markers - * +
    .replace(/^[-*+]\s+/gm, '')
    // Remove ordered list markers 1. 2. etc
    .replace(/^\d+\.\s+/gm, '')
    // Remove blockquotes >
    .replace(/^>\s*/gm, '')
    // Remove horizontal rules
    .replace(/^[-*_]{3,}\s*$/gm, '')
    // Remove extra newlines
    .replace(/\n{2,}/g, ' ')
    // Replace single newlines with space
    .replace(/\n/g, ' ')
    // Remove extra spaces
    .replace(/\s{2,}/g, ' ')
    .trim();
};

/**
 * Strip reedle UI directive blocks (e.g. reedle:suggestions) from AI response content.
 * Preserves content blocks like reedle:flashcard.
 */
export const stripReedleDirectives = (text) => {
  if (!text) return '';
  return text
    .replace(/```reedle:suggestions\n[\s\S]*?```/g, '')
    .replace(/\n{2,}$/g, '\n')
    .trim();
};

/**
 * Strip markdown and truncate to max length
 */
export const stripAndTruncate = (text, maxLen = 50) => {
  const plain = stripMarkdown(text);
  return plain.length > maxLen ? plain.substring(0, maxLen) + '...' : plain;
};

